<template>
    <div class="contrast">
        <ul class="contrast-fundlist">
            <li class="card-one" @click="$router.go(0)"><i class="el-icon-delete mr5"></i>清空所选基金</li>
            <li class="card-one" v-for="(list,ind) in fundList" :key="ind+'li'">
                <div class="search" v-if="list.search">
                    <div class="mt10">添加基金</div>
                    <div class="search-box mt10">
                        <el-select v-model="list.searchType" class="select-one" placeholder="请选择类型">
                            <el-option label="私募产品"  value="私募产品"></el-option>
<!--                            <el-option label="比较基准" value="比较基准"></el-option>-->
<!--                            <el-option label="模拟组合" value="模拟组合"></el-option>-->
<!--                            <el-option label="内部产品" value="内部产品"></el-option>-->
<!--                            <el-option label="展恒指数" value="展恒指数"></el-option>-->
                        </el-select>
                        <div class="search-box-form">
                            <el-autocomplete placeholder="请输入产品关键字" v-model="list.searchValue" ref="searchRef" class="autocomplete-with-select" hide-loading :fetch-suggestions="(queryString, cb) => {querySearchAsync(queryString, cb, list.searchType);}" @select="selectFun($event, ind)">
                                <template slot-scope="{ item }">
                                    <div v-if="item.nodata=='无数据'" class="empty">{{ item.nodata }}</div>
                                    <span :title="item.secuNameAbbr">{{ item.secuNameAbbr }}</span>
                                </template>
                            </el-autocomplete>
                            <i class="el-icon-search"></i>
                        </div>
                    </div>
                </div>
                <div v-else style="line-height: 24px;">
                    {{list.fundname}}
                    <div class="line" :style="'background:' + fundColor[ind] + ';'"></div>
                    <img src="../../assets/images/delete.png" class="delete" alt="" @click="deleteItem(list,ind)">
                </div>
            </li>
        </ul>
        <div class="card-one" style="padding: 45px 30px;">
            <div class="row-four">基本概况</div>
            <table class="contrast-table mt30 contrast1" cellspacing="0">
                <tbody>
                    <tr v-for="(item,i) in infoTableData" :key="i+'row'">
                        <td v-for="(term,t) in item" :key="t+'col'">{{term}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-one" style="padding: 45px;">
            <div class="row-four">净值走势对比</div>
            <div class="time-tab">
                <span>选择时间：</span>
                <el-radio-group v-model="netValTime" class="radio-btnt" value-key="id">
                    <el-radio-button label="-1">成立以来</el-radio-button>
                    <el-radio-button label="2" >最近一月</el-radio-button>
                    <el-radio-button label="3" >最近三月</el-radio-button>
                    <el-radio-button label="4" >最近半年</el-radio-button>
                    <el-radio-button label="5" >最近一年</el-radio-button>
                    <el-radio-button label="0" >今年以来</el-radio-button>
                </el-radio-group>
            </div>
            <div v-show="innerCodeStr == ''" class="nodata">
                <img src="https://www.myfund.com/images/investmentAdviser16.png" alt="">
                <p class="mt10">暂无数据</p>
            </div>
            <div v-show="innerCodeStr != ''" style="width:100%;height:383px;" id="jzzs"></div>
            <el-table class="table-two mt50" :data="indexTable" border>
                <el-table-column label="名称" prop="0" width="200"></el-table-column>
                <el-table-column label="累计收益" prop="1"></el-table-column>
                <el-table-column label="最大回撤" prop="2"></el-table-column>
                <el-table-column label="波动率" prop="3"></el-table-column>
                <el-table-column label="下行标准差" prop="4"></el-table-column>
                <el-table-column label="夏普比率" prop="5"></el-table-column>
                <el-table-column label="索提诺比率" prop="6"></el-table-column>
                <el-table-column label="卡玛比率" prop="7"></el-table-column>
            </el-table>
            <div v-if="releteTableData.length>0">
                <el-row class="row-two mt50"><h3 class="title">基金相关性</h3></el-row>
                <table class="strategy-table mt20" cellspacing="0">
                    <tr>
                        <th v-for="(relate,r1) in releteTableData[0]" :key="r1+'reh'">{{relate}}</th>
                    </tr>
                    <tr v-for="(item1,i1) in releteTableData.slice(1)" :key="i1+'rer'">
                        <td v-for="(item2,i2) in item1" :key="i2+'red'" :style="classObj(item2)">{{i2==0? item2 : parseFloat(item2).toFixed(4)}}</td>
                    </tr>
                </table>
            </div>
            <div v-if="excessTableData.length>0">
                <el-row class="row-two mt50"><h3 class="title">超额收益序列相关性</h3></el-row>
                <table class="contrast-table mt20" cellspacing="0">
                    <tbody>
                        <tr>
                            <td>名称</td>
                            <td v-for="(val1,s1) in fundList" :key="s1+'name'"><span v-if="!val1.search">{{val1.fundname}}</span></td>
                        </tr>
                        <tr>
                            <td>选择策略</td>
                            <td v-for="(val2,s2) in fundList" :key="s2+'str'">
                                <el-select v-if="!val2.search" v-model="val2.baseCode" class="select-one" @change="val => {baseCodeChange(val, s2)}">
                                    <el-option v-for="(strategy,ind) in baseList" :key="ind+'cl'" :label="strategy.name" :value="strategy.code"></el-option>
                                </el-select>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="strategy-table mt20" cellspacing="0" v-loading="strategyLoading">
                    <tr>
                        <th v-for="(val,h) in excessTableData[0]" :key="h+'excessh'">{{val}}</th>
                    </tr>
                    <tr v-for="(item1,i1) in excessTableData.slice(1)" :key="i1+'excessr'">
                        <td v-for="(item2,i2) in item1" :key="i2+'dexcessd'" :style="classObj(item2)">{{i2==0? item2 : parseFloat(item2).toFixed(4)}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    name: "topSearch",
    data () {
        return {
            fundList: [
                {
                    search: true,
                    fundname: '',
                    searchValue: '',
                    innerCode: '',
                    searchType: '私募产品',
                    baseCode: 1037160,
                },
                {
                    search: true,
                    fundname: '',
                    searchValue: '',
                    innerCode: '',
                    searchType: '私募产品',
                    baseCode: 1037160,
                },
                {
                    search: true,
                    fundname: '',
                    searchValue: '',
                    innerCode: '',
                    searchType: '私募产品',
                    baseCode: 1037160,
                },
                {
                    search: true,
                    fundname: '',
                    searchValue: '',
                    innerCode: '',
                    searchType: '私募产品',
                    baseCode: 1037160,
                },
                {
                    search: true,
                    fundname: '',
                    searchValue: '',
                    innerCode: '',
                    searchType: '私募产品',
                    baseCode: 1037160,
                },
            ],
            fundColor: ['#01B4FF','#FF8F2C','#D12626','#F4CC2E','#9833DE',],
            netValTime: '-1',
            tabledata: ['投资策略','基金状态','成立时间','最新净值',],
            infoTableData:[
                ['投资策略','','','','',''],
                ['基金状态','','','','',''],
                ['成立时间','','','','',''],
                ['最新净值','','','','',''],
            ],
            innerCodeStr: '',
            indexTable: [],
            releteTableData: [],
            excessTableData: [],// 超额收益序列相关性
            baseList: [],
            strategyLoading: true,
        }
    },
    mounted() {
        // 基金自选产品
        let codes = this.$route.params.innerCodes
        if(codes) {
            codes.forEach((item,i) => {
                this.fundList[i] = {
                    search: false,
                    fundname: item.secuNameAbbr,
                    searchValue: '',
                    innerCode: item.innerCode,
                    searchType: '1',
                    baseCode: 1037160,
                }
                this.innerCodeStr = this.getStr(this.fundList)
            })
        }
        this.getList()
        this.getBaseList()
    },
    watch: {
        netValTime:{
            handler(val){
                this.getPrivateFundPhaseCharts()
                this.getPrivateFundIndexValue()
                this.getPrivateFundRelatedIndex()
                this.getPrivateFundExcessRelatedIndex()
            },
        },
    },
    computed: {
        classObj(state) {
            return (state) => {
                if(state >= -1 && state < -0.6) {
                    return { background: '#95B8C9' }
                } else if(state >= -0.6 && state < -0.3) {
                    return { background: '#80AABF' }
                } else if(state >= -0.3 && state < 0) {
                    return { background: '#679AB2' }
                } else if(state >= 0 && state < 0.3) {
                    return { background: '#4D88A5' }
                } else if(state >= 0.3 && state < 0.6) {
                    return { background: '#1A678C' }
                } else if(state >= 0.6 && state <= 1) {
                    return { background: '#024B6E' }
                }
            }
        },
    },
    methods: {
        querySearchAsync (queryString, cb, type) {
            if (queryString !== '') {
                this.$http.post(this.$apiPath.GetCompareFuzzySeachResult, {
                    innerType: type,      //内部类型:1私募产品;2模拟组合;3比较基准;4内部产品;5展恒指数
                    KeyWords: queryString //模糊查询关键词
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == 200) {
                        let search = res.data.data.dataList;
                        if (search.length > 0) {
                            cb(search);
                        } else {
                            cb([{nodata:'无数据'}]);
                        }
                    }
                })
            } else {
                cb([]);
            }
        },
        selectFun(val,i) {
            let vm = this
            if(val.nodata!='无数据') {
                vm.fundList[i] = {
                    search: false,
                    fundname: val.secuNameAbbr,
                    searchValue: '',
                    innerCode: val.innerCode,
                    searchType: val.innerType,
                    baseCode: 1037160,
                }
                vm.innerCodeStr = vm.getStr(vm.fundList)
                vm.getList()
            }
        },
        deleteItem(val,i) {
            let vm = this
            val.search = true
            val.searchType = '私募产品'
            Vue.set(vm.fundList,i,val)
            vm.innerCodeStr = vm.getStr(vm.fundList)
            vm.getList()
        },
        getStr(arr) {
            let str = ''
            arr.forEach(item => {
                if(item.search == false) {
                    str += item.innerCode + ','
                }
            })
            return str;
        },
        getList() {
            this.getPrivateFundCompareInfo()
            this.getPrivateFundPhaseCharts()
            this.getPrivateFundIndexValue()
            this.getPrivateFundRelatedIndex()
            this.getPrivateFundExcessRelatedIndex()
        },
        getPrivateFundCompareInfo() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetPrivateFundCompareInfo, {
                InnerCodeStr: vm.innerCodeStr.slice(0, -1), //基金代码字符串
            }).then(res => {
                if (res.data.code == 200) {
                    // console.log(res);
                    vm.infoTableData = []
                    let list = res.data.data.list
                    let temp1 = [vm.tabledata[0]];
                    let temp2 = [vm.tabledata[1]];
                    let temp3 = [vm.tabledata[2]];
                    let temp4 = [vm.tabledata[3]];
                    let isNull = 0
                    for (var j = 0; j < vm.fundList.length; j++) {
                        if(vm.fundList[j].search) {
                            isNull ++;
                            temp1.push("");
                            temp2.push("");
                            temp3.push("");
                            temp4.push("");
                        }
                        else{
                            let nav = list[j-isNull].newestEquity
                            temp1.push(list[j-isNull].primaryType);
                            temp2.push(list[j-isNull].listedState);
                            temp3.push(list[j-isNull].createDate);
                            temp4.push((nav=='--'? '--' : parseFloat(nav).toFixed(4)) + ' ('+list[j-isNull].newestDate+')');
                        }
                    }
                    vm.infoTableData.push(temp1);
                    vm.infoTableData.push(temp2);
                    vm.infoTableData.push(temp3);
                    vm.infoTableData.push(temp4);
                    // console.log(vm.infoTableData);
                } else [
                    vm.infoTableData = [
                        ['投资策略','','','','',''],
                        ['基金状态','','','','',''],
                        ['成立时间','','','','',''],
                        ['最新净值','','','','',''],
                    ]
                ]
            })
        },
        getPrivateFundPhaseCharts() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetPrivateFundPhaseCharts, {
                InnerCodeStr: vm.innerCodeStr.slice(0, -1),    //基金代码字符串
                Region: vm.netValTime,    //-1成立以来，0今年以来，2近一月，3近三月，4近六月，5近一年
            }).then(res => {
                if (res.data.code == 200) {
                    // console.log(res);
                    let xdata = res.data.data
                    let seriesData = []
                    xdata.nameList.forEach((item,i) => {
                        seriesData.push({
                            name:item,
                            type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                            data: xdata.dataList[i]
                        })
                        if(item == '沪深300') {
                            seriesData[i].itemStyle = {
                                color: "#959595", //线的颜色以及头部显示的颜色
                            }
                        }
                    });
                    vm.$commonEcharts.echartsSix('jzzs',xdata.dateList,seriesData,true,vm.fundColor)
                }
            })
        },
        getPrivateFundIndexValue() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetPrivateFundIndexValue, {
                InnerCodeStr: vm.innerCodeStr.slice(0, -1), //基金代码字符串
                Region: vm.netValTime,    //-1成立以来，0今年以来，2近一月，3近三月，4近六月，5近一年
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let list = res.data.data.dataList
                    let names = res.data.data.nameList
                    for(let i = 0; i < list.length; i++) {
                        list[i].unshift(names[i])
                    }
                    vm.indexTable = list
                } else {
                    vm.indexTable = []
                }
            })
        },
        // 相关性
        getPrivateFundRelatedIndex() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetPrivateFundRelatedIndex, {
                InnerCodeStr: vm.innerCodeStr.slice(0, -1),
                Region: vm.netValTime,
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    vm.releteTableData = res.data.data
                }
            }).catch(err => {})
        },
        getBaseList() {
            let vm=this;
            vm.$http.post(vm.$apiPath.getPrivateFundDatePhase,{
                InnerCode:'0'
            }).then(res=>{
                // console.log(res);
                if(res.data.code==200){
                    let sdata=res.data.data;
                    sdata.baseList.forEach((val,ind)=>{
                        vm.baseList.push({
                            name:val.name,
                            code:val.value
                        })
                    })
                    this.$forceUpdate()
                }
            })
        },
        baseCodeChange(val,i) {
            this.fundList[i].baseCode = val
            this.$forceUpdate()
            this.strategyLoading = true
            this.getPrivateFundExcessRelatedIndex()
        },
        getPrivateFundExcessRelatedIndex() {
            let vm = this
            let codes = []
            vm.fundList.forEach(item => {
                if(item.search == false) {
                    codes.push({
                        InnerCode: item.innerCode,
                        BaseCode: item.baseCode
                    })
                }
            })
            vm.$http.post(vm.$apiPath.GetPrivateFundExcessRelatedIndex,{
                Region: vm.netValTime,
                InnerCodes: codes,
            }).then(res=>{
                // console.log(res);
                vm.strategyLoading = false
                if(res.data.code==200){
                    vm.excessTableData = res.data.data
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.contrast {
    &-fundlist {
        width: 1200px;margin: 0 auto;display: flex;
        li {
            width: 207px;height: 120px;position: relative;margin-right: 2px;color: @mainColor;font-size: 16px;display: flex;align-items: center;justify-content: center;font-weight: bold;text-align: center;
            .search {
                font-size: 14px;color: @color6;
                &-box {
                    position: relative;
                    .empty{margin: 0;text-align: center;color: @color9;}
                    .el-icon-search {position: absolute;right: 10px;top: 50%;transform: translateY(-50%);}
                    /deep/.el-input__inner {width: 156px;height: 26px;font-size: 12px;line-height: 26px;padding: 0 30px 0 15px;border-color: @colorD5;}
                    &-form {position: relative;margin-top: 10px;}
                }
            }
        }
        li:first-child {width: 165px;color: @color3;cursor: pointer;}
        li:last-child {margin-right: 0;}
        .line {content: "";position: absolute;left: 50%;transform: translateX(-50%);bottom: 0;width: 196px;height: 3px;}
        .delete {cursor: pointer;position: absolute;top: 6px;right: 6px;}
        .mr5{margin-right:5px !important;}
    }
    &-table {
        width: 100%;border: 1px solid @borderColor;font-size: 14px;
        tbody {
            tr {
                td {box-sizing: border-box;padding:10px 20px;width:207px;color: @color3;border-right: 1px solid @borderColor;border-bottom: 1px solid @borderColor;}
                td:first-child {background: @oColor5;width: 12%;text-align: center;}
                td:last-child {border-right: 0;}
                /deep/.el-input__inner {width: 156px;height: 26px;font-size: 12px;line-height: 26px;padding: 0 30px 0 15px;border-color: @colorD5;}
            }
            tr:last-child td {border-bottom: 0;}
        }
    }
    .contrast1 {
        td:last-child {width: 15.3%;}
    }
    .time-tab {
        font-size: 14px;color: @color6;padding: 5px 0 20px;
        /deep/.el-radio-button {margin: 0 20px;}
    }
    .nodata {width: 100%;text-align: center;font-size: 20px;color: @color9;padding: 125px 0;}
    .strategy-table{
        font-size: 14px;
        tr {
            th {min-width: 120px;}
            td {color: @whiteColor;}
            td:first-child {color:@mainColor;background:@oColor4;}
        }
        tr:first-child {color:@mainColor;background:@oColor4;}
    }
}
</style>
